export function getdata() {
	var obj = {
		headDataII: [{
				title: '负债和所有者权益（或股东权益）',
				prop: 'title',
				width: "250px",
				custom: true,
				align:'left',
			}, {
				title: "行次",
				prop: "grade",
				width: "100px",
				custom: true,
			},
			{
				title: "期末余额",
				custom: true,
				prop: "cwbbqykjzd_0_x_1",
				width: "200px",
				align:'right',
			}, {
				title: "上年年末余额",
				prop: "cwbbqykjzd_0_x_2",
				width: "200px",
				custom: true,
				align:'right',
			},
		],
		headDataI: [{
				title: "资产",
				prop: "title",
				width: "250px",
				custom: true,
				align:'left',
			}, {
				title: "行次",
				prop: "grade",
				width: "100px",
				custom: true,
			},
			{
				title: "期末余额",
				prop: "cwbbqykjzd_0_x_1",
				custom: true,
				width: "200px",
				align:'right',
			},
			{
				title: '上年年末余额',
				prop: 'cwbbqykjzd_0_x_2',
				width: "200px",
				custom: true,
				align:'right',
			},

		],
		tableDataII: [{
				title: '流动负债：',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_35_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_35_1",
					cellType: "1",
					cellVal: "240040043.08"
				},

			},
			{
				title: '短期借款',
				grade: '68',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_35_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_35_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: '应付票据',
				grade: '69',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_36_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_36_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: '应付账款',
				grade: '70',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_37_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_37_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: '预收账款',
				grade: '71',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_38_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_38_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: '应付工资',
				grade: '72',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_39_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_39_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: '应付福利费',
				grade: '73',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_40_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_40_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: '应付股利',
				grade: '74',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_41_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_41_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: '应交税金',
				grade: '75',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_42_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_42_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: '其他应交款',
				grade: '80',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_43_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_43_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: '其他应付款',
				grade: '81',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_44_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_44_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: '预提费用',
				grade: '82',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_45_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_45_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: '预计负债',
				grade: '83',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_46_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_46_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: '一年内到期的长期负债',
				grade: '86',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_47_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_47_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: '其他流动负债',
				grade: '90',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_48_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_48_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: '',
				grade: '',
				disabledcwbbqykjzd_0_x_1: true,
				disabledcwbbqykjzd_0_x_2: true,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_xxxxxxx_1",
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_xxxxxxx_2",
				},
			}, {
				title: '流动负债合计',
				grade: '100',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_49_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_49_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: '长期负债：',
				grade: '',
				disabledcwbbqykjzd_0_x_1: true,
				disabledcwbbqykjzd_0_x_2: true,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_50_1",
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_50_2",
				},
			}, {
				title: '长期借款',
				grade: '101',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_51_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_51_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: '应付债券',
				grade: '102',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_52_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_52_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: '长期应付款',
				grade: '103',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_53_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_53_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: '专项应付款',
				grade: '106',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_20_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_20_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: '其他长期负债',
				grade: '108',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_21_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_21_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: '长期负债合计',
				grade: '110',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_22_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_22_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: '递延税项：',
				grade: '',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_23_1",
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_23_2",
				},
			}, {
				title: '递延税款贷项',
				grade: '111',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_24_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_24_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: '负债合计',
				grade: '114',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_25_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_25_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: '',
				grade: '',
				disabledcwbbqykjzd_0_x_1: true,
				disabledcwbbqykjzd_0_x_2: true,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_xxxxxxx_1",
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_xxxxxxx_2",
				},
			}, {
				title: '所有者权益（或股东权益）：',
				grade: '',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_26_1",
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_26_2",
				},
			}, {
				title: '实收资本(或股本)',
				grade: '115',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_27_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_27_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: '减：已归还投资',
				grade: '116',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_29_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_29_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: '实收资本(或股本)净额',
				grade: '117',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_30_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_30_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: '资本公积',
				grade: '118',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_31_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_31_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: '盈余公积',
				grade: '119',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_32_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_32_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: '其中：法定公益金',
				grade: '120',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_33_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_33_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: '未分配利润',
				grade: '121',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_34_3",
					cellType: "0",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_34_3",
					cellType: "0",
					cellVal: "240040043.08"
				},
			}, {
				title: '所有者权益（或股东权益）合计',
				grade: '122',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_34_3",
					cellType: "0",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_34_3",
					cellType: "0",
					cellVal: "240040043.08"
				},
			}, {
				title: '负债和所有者权益（或股东权益）总计',
				grade: '135',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_34_3",
					cellType: "0",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_34_3",
					cellType: "0",
					cellVal: "240040043.08"
				},
			}

		],
		tableDataI: [{
				title: "流动资产：",
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_1_1",
					cellType: "1",
					cellVal: "240040043.08",
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_1_1",
					cellType: "1",
					cellVal: "240040043.08",
				},

			},
			{
				title: "货币资金",
				grade: '1',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_1_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_1_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "短期投资",
				grade: '2',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_2_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_2_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "应收票据",
				grade: '3',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_3_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_3_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "应收股利",
				grade: '4',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_4_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_4_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "应收利息",
				grade: '5',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_5_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_5_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "应收账款",
				grade: '6',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_6_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_6_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "其他应收款",
				grade: '7',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_7_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_7_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "预付账款",
				grade: '8',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_8_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_8_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "应收补贴款",
				grade: '9',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_9_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_9_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "存货",
				grade: '10',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_10_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_10_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "待摊费用",
				grade: '11',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_11_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_11_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "一年内到期的长期债权投资",
				grade: '21',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_12_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_12_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "其他流动资产",
				grade: '24',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_13_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_13_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "流动资产合计",
				grade: '31',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_14_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_14_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "长期投资：",
				grade: '',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellType: "0",
					cellCode: '11111111'
				},
				cwbbqykjzd_0_x_2: {
					cellType: "0",
					cellCode: '11111111'
				},
			}, {
				title: "长期股权投资",
				grade: '32',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_15_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_15_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "长期债权投资",
				grade: '34',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_16_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_16_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "长期投资合计",
				grade: '38',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_17_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_17_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "固定资产：",
				grade: '',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_18_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_18_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "固定资产原价",
				grade: '39',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_19_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_19_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "减：累计折旧",
				grade: '40',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_20_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_20_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "固定资产净值",
				grade: '41',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_21_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_21_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "减：固定资产减值准备",
				grade: '42',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_22_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_22_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "固定资产净额",
				grade: '43',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_23_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_23_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "工程物资",
				grade: '44',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_24_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_24_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "在建工程",
				grade: '45',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_25_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_25_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "固定资产清理",
				grade: '46',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_26_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_26_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "固定资产合计",
				grade: '50',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_27_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_27_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "无形资产及其他资产：",
				grade: '',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_28_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_28_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "无形资产",
				grade: '51',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_29_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_29_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "长期待摊费用",
				grade: '52',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_30_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_30_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "其他长期资产",
				grade: '53',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_31_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_31_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "无形资产及其他资产合计",
				grade: '60',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_32_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_32_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "",
				grade: '',
				disabledcwbbqykjzd_0_x_1: true,
				disabledcwbbqykjzd_0_x_2: true,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_32_1",
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_32_2",
				},
			}, {
				title: "递延税项：",
				grade: '',
				disabledcwbbqykjzd_0_x_1: true,
				disabledcwbbqykjzd_0_x_2: true,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_33_1",
					cellType: "1",
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_33_2",
					cellType: "1",
				},
			}, {
				title: "递延税款借项",
				grade: '61',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_33_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_33_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "资产合计",
				grade: '67',
				disabledcwbbqykjzd_0_x_1: false,
				disabledcwbbqykjzd_0_x_2: false,
				cwbbqykjzd_0_x_1: {
					cellCode: "cwbbqykjzd_0_34_3",
					cellType: "0",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_0_x_2: {
					cellCode: "cwbbqykjzd_0_34_3",
					cellType: "0",
					cellVal: "240040043.08"
				},
			}
		]
	}
	return obj
}
